import { isEqual } from 'lodash';
import { NewProduct } from 'store/productManagement/reducer.types';

export const hasUnsavedProductChanges = (
  initialProduct: NewProduct | null,
  product: NewProduct,
  isReadOnly: boolean,
): boolean => {
  if (isReadOnly) return false;

  return Boolean(initialProduct && product && !isEqual({ ...initialProduct, name: '' }, { ...product, name: '' }));
};
